import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de Nematicida Microbiologico
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function NematicidaMicrobiologico(props) {
  useEffect(() => {
    const title = 'nematicidaMicrobiologico.nematicidaMicrobiologico';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.NEMATICIDA_MICROBIOLOGICO}
      insumoURL='nematicidas-microbiologicos'
      viewKey='nematicidaMicrobiologico'
      deleteMessageSucess={formatMessage(
        'nematicidaMicrobiologico.nematicidaMicrobiologicoRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('nematicidaMicrobiologico.falhaAoExcluirNematicidaMicrobiologico')}
      mensagemDelete={formatMessage('nematicidaMicrobiologico.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'nematicidaMicrobiologico';
  })[0].content
});

export default connect(mapStateToProps)(NematicidaMicrobiologico);
